import { createAsyncThunk } from 'legacy/lut/store/utils/createAsyncThunk'

import { getPartnerContactsCrud } from '../lib/getPartnerContactsCrud'
import { DELETE_CONTACT } from '../model/constants'
import { CONTACTS_DATA_SOURCE, IPartnerContact } from '../model/types'
import { selectContactsFilters } from '../selectors/selectContactsFilters'

export const deleteContact = createAsyncThunk<number, IPartnerContact>(
  DELETE_CONTACT,
  async (deleteItem, { getState }) => {
    const { programType, partnerId } = selectContactsFilters(getState())
    const crud = getPartnerContactsCrud({ programType, partnerId })
    await crud.delete(CONTACTS_DATA_SOURCE, structuredClone(deleteItem), 'EntryId')
    return deleteItem.EntryId
  }
)
